<template>
    <div class="home px-3">
        <Stepper :steps="steps"
                 :step="step" />
        <div v-if="!showAgreeTerm" class="d-flex flex-row justify-content-center">
            <a class="choose text-center d-flex flex-column justify-content-center align-items-center"
               v-for="(item, index) in descriptions"
               v-on:click="isNewFriend(item.newFriend)"
               :data-ga="item.newFriend?'新保險網站_選擇身分_新業務':'新保險網站_選擇身分_原業務'"
               :class="{ active: newFriend == item.newFriend }"
               :key="index">
                <div>我是{{item.who}}</div>
                <div class="mb-2">
                    <span>想{{item.action}}</span>
                    <b>{{item.want}}</b>
                </div>
                <div class="choose__circle">
                    <img :src="item.active"
                         :alt="item.activeAlt"
                         v-if="newFriend == item.newFriend" />
                    <img :src="item.img"
                         :alt="item.alt"
                         v-else />
                </div>
            </a>
        </div>
        <div v-if="!showAgreeTerm" class="d-flex justify-content-center align-items-center my-5">
            <b-button pill
                      variant="primary"
                      class="button"
                      v-on:click="showModal">下一步</b-button>
        </div>
        <div v-if="!showAgreeTerm" class="d-flex justify-content-center align-items-center my-5">
            <span class="warning-text" v-if="!newFriend"> 您選擇的是原業務夥伴，會由原業務同仁與您聯繫。 </span>
        </div>
        <Banner :srcId="this.srcId" />
        <Modal :show="show"
               :description="errorMessage"
               @onClose="onClose">
            <div slot="action"
                 class="d-flex justify-content-center align-items-center my-5">
                <b-button pill
                          variant="primary"
                          class="button"
                          v-on:click="onClose">確認</b-button>
            </div>
        </Modal>
        <b-modal v-model="showAgreeTerm"
                 size="lg"
                 hide-footer
                 title="請閱覽以下內容並將卷軸往下拉至最底"
                 no-close-on-esc
                 no-close-on-backdrop>
            <div>
                <div class="agreeTerm border mx-auto w-100 overflow-auto rounded" v-html="agreeTerm" v-on:scroll.passive="onScroll"/>
                <div class="bounce d-flex justify-content-center mt-n4 div-arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="arrow">
                        <title>chevron-down</title>
                        <path fill="currentColor" d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
                    </svg>
                </div>
            </div>
            <div class="d-flex justify-content-center align-items-center mb-2">
                <b-form-checkbox class="mb-1"
                                 size="lg"
                                 value="0"
                                 v-bind:disabled="!scrollToBottom"
                                 v-model="agree"
                                 required>
                    我已閱讀並同意以上事項
                </b-form-checkbox>
            </div>
            <div class="d-flex justify-content-center align-items-center mt-3 mb-2">
                <b-button class="btn mr-3 btn-agreeTerm"
                          v-on:click="closeModal">返回</b-button>
                <b-button variant="primary"
                          class="btn btn-agreeTerm"
                          v-bind:disabled="!agree"
                          v-on:click="next">下一步</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
// @ is an alias to /src
import Stepper from '@/components/Stepper.vue';
import Banner from '@/components/Banner.vue';
import Modal from '@/components/Modal.vue';
import { request } from '@/service';

export default {
    name: 'Home',
    components: {
        Stepper,
        Banner,
        Modal,
    },
    created() {
        this.$store.dispatch('setSubHeaderShow', true);
        this.checkToken();
        this.getAddresses();
    },
    data() {
        return {
            showAgreeTerm: false,
            show: false,
            srcId: '',
            errorMessage: '',
            step: 0,
            descriptions: [
                {
                    newFriend: false,
                    who: '富邦人壽的保戶',
                    action: '找',
                    want: '原業務夥伴',
                    img: require('../assets/images/find-my-friend.svg'),
                    active: require('../assets/images/find-my-friend-active.svg'),
                    alt: '未選取我是既有保戶',
                    activeAlt: '已選取我是既有保戶'
                },
                {
                    newFriend: true,
                    who: '新朋友',
                    action: '預約',
                    want: '新的業務夥伴',
                    img: require('../assets/images/high-five.svg'),
                    active: require('../assets/images/high-five-active.svg'),
                    alt: '未選取我是新朋友',
                    activeAlt: '已選取我是新朋友'
                }
            ],
            agreeTerm: '',
            scrollToBottom: false,
            agree: false,
        };
    },
    computed: {
        newFriend() {
            return this.$store.state.newFriend;
        },
        steps() {
            return this.newFriend ? ['選擇身分', '填寫資料'] : ['選擇身分', '認證身分', '填寫資料'];
        }
    },
    mounted() {
        request({
            method: 'GET',
            api: '/api/reservationTerm',
        }).then(response => {
            if (response.status === 200 && response.data) {
                this.agreeTerm = response.data.content;
            } else {
                this.$notify({
                    group: 'alert',
                    title: '發生錯誤，目前無法取得個人資料保護法告知說明書內容。',
                    type: 'error',
                });
            }
        }).catch((error) => {
            console.error(error);
            this.$notify({
                group: 'alert',
                title: '發生錯誤，目前無法取得個人資料保護法告知說明書內容。',
                type: 'error',
            });
        });
    },
    methods: {
        checkToken() {
            this.$store.dispatch('getTokenInfo').then(response => {
                this.srcId = response.data.srcId;
            }).catch(error => {
                if (error.status === 401) {
                    this.errorMessage = error.message;
                    this.show = true;
                } else {
                    this.$notify({
                        group: 'alert',
                        title: '發生錯誤',
                        type: 'error',
                    });
                }
            });
        },
        isNewFriend(boolean) {
            this.$store.dispatch('setNewFriend', boolean);
        },
        showModal() {
            this.showAgreeTerm = true;
            this.scrollToBottom = false;
            this.agree = false;
        },
        closeModal() {
            this.showAgreeTerm = false;
            this.scrollToBottom = false;
            this.agree = false;
        },
        next() {
            if (this.newFriend) {
                this.$router.push({ name: 'FormData', params: { newFriend: this.newFriend } });
            } else {
                this.$router.push({ name: 'IdNoVerification' });
            }
        },
        getAddresses() {
            request({
                method: 'GET',
                api: '/api/zipCode',
            })
                .then(res => {
                    this.$store.dispatch('setArea', res.data.countyList);
                });
        },
        onScroll(event) {
            if (event.target.scrollTop + event.target.offsetHeight >= event.target.scrollHeight) {
                this.scrollToBottom = true;
            }
        },
        onClose() {
            this.show = false;
            const protocol = window.location.protocol;
            const host = window.location.host;
            window.location.href = `${protocol}//${host}/fubonagent/`;
        },
    }
};
</script>

<style scoped lang="scss">
a {
    text-decoration: underline;
}
.choose {
    text-decoration: none !important;
    color: inherit !important;
    width: 50%;
    height: 175px;
    max-width: 255px;
    border: 1px solid #cccccc;
    border-radius: 5px;
    cursor: pointer;
    &:first-child {
        margin-right: 30px;
    }
    @media (max-width: 600px) {
        &:first-child {
            margin-right: 10px;
        }
    }
    @media (max-width: 321px) {
        & {
            font-size: 0.875rem;
        }
        &:first-child {
            margin-right: 5px;
        }
    }
    .choose__circle {
        img {
            width: 70px;
            height: 70px;
        }
    }
}
.active {
    border: 3px solid $primary;

    @media (max-width: 325px) {
        & {
            border-width: 2px;
        }
    }
}
.warning-text {
    color: red;
}
.bg-agreeTerm {
    background-color: #DDDDDD;
}
.btn-agreeTerm {
    width: 110px;
}
@keyframes bounce {
    from {
        transform: translateY(0px);
    }
    to {
        transform: translateY(-10px);
    }
}
@-webkit-keyframes bounce {
    from {
        transform: translateY(0px);
    }
    to {
        transform: translateY(-10px);
    }
}
::v-deep .modal-header {
    border-bottom: 0 none;
    margin-bottom: 0;
}
.bounce {
    animation: bounce 1s infinite alternate;
    -webkit-animation: bounce 1s infinite alternate;
}
.agreeTerm {
    height: 300px;
}
.div-arrow {
    color: rgb(59, 183, 176);
    .arrow {
        height: 55px;
        width: 55px;
        transform: rotate(0deg);
    }
}
</style>
